import React from 'react';

import * as S from './styles';

export type CheckboxProps = {
  label?: string;
  checked?: boolean;
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void;
  labelDirection?: 'left' | 'right';
};

const Checkbox = ({ label, checked, onChange, labelDirection = 'left', ...rest }: CheckboxProps) => {
  return (
    <S.Container {...rest}>
      {labelDirection === 'left' && label}
      <div>
        <input
          name="checkbox"
          type="checkbox"
          role="checkbox"
          aria-checked={checked ? 'true' : 'false'}
          checked={checked}
          onChange={onChange}
        />
        <span />
      </div>
      {labelDirection !== 'left' && label}
    </S.Container>
  );
};

export default Checkbox;
